module.exports = __webpack_public_path__ + "img/card3Img.240a1849.png";